
const isSameDay = (d1, d2) => {
    return (
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate()
    );
};

const isYesterday = (date, today) => {
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    return isSameDay(date, yesterday);
};

// Formatea la hora del mensaje (ej: 14:35)
export const formatMessageTime = (dateString) => {
    const date = new Date(dateString);

    return date.toLocaleTimeString('es-ES', {
        hour: '2-digit',
        minute: '2-digit',
    });
};

// --- Formateo de fecha ----
// Si es hoy mostrar la hora
// Si es ayer mostrar "Ayer"
// Si es dias anteriores mostrar la fecha

export const formatConversationDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();

    if (isSameDay(date, now)) {
        return date.toLocaleTimeString('es-ES', {
            hour: '2-digit',
            minute: '2-digit',
        });
    }

    if (isYesterday(date, now)) {
        return 'Ayer';
    }

    return date.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
    });
};


export const formatChatDateLabel = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();

    const dateLocal = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const todayLocal = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const diffTime = todayLocal - dateLocal;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    if (diffDays === 0) return "Hoy";
    if (diffDays === 1) return "Ayer";


    // if (isSameDay(date, now)) {
    //     return "Hoy";
    // }

    // if (isYesterday(date, now)) {
    //     return "Ayer";
    // }

    return date.toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
    });
}


